enum QuestionnaireKind {
    OFFICIAL = 0,
    CUSTOM = 1,
}

export default QuestionnaireKind;
